import EditIcon from '@mui/icons-material/BorderColorOutlined';
import { Box, IconButton, List, ListItem, ListItemText, Popover, Paper, Tooltip, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import NotificationRuleDescription from '../notifications/NotificationRuleDescription';

import { DataAPIContext, GET_ONE } from '../api';
import { NOTIFICATION_RULE_TEMPLATES, RULES_MATCH_ANY } from '../notifications/utils';

export const RulesetPreview = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const [ruleset, setRuleset] = React.useState(props.ruleset);
    const [syncActive, setSyncActive] = React.useState(false);

    React.useEffect(() => {
        console.log('preview', props.ruleset, props.id);
        if (!!ruleset && (typeof ruleset.rules !== "undefined")) { return; }
        if (!ruleset && !props.id) { return; }
        if (!props.id) { return; }
        let active = true;
        setSyncActive(true);
        dataAPI(GET_ONE, 'notification_ruleset', { id: props.id }).then((res) => {
            if (!active) { return; }
            setRuleset(res.data);
            props.onChange && props.onChange(res.data);
            setSyncActive(false);
        });
        return () => { active = false; };
    });

    if (syncActive) {
        return (<>{typeof props.loadingMessage !== "undefined" ? props.loadingMessage : 'Loading ruleset preview...'}</>)
    } else if (!ruleset) {
        return (<>{typeof props.emptyMessage !== "undefined" ? props.emptyMessage : 'No ruleset'}</>)
    } else {
        return (<>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {ruleset.name}{ !props.disableEdit && (<>&nbsp;<Tooltip title="Edit ruleset"><IconButton href={`/notifications/rulesets/${ruleset.id}`} target="_blank"><EditIcon color="primary" fontSize="small"/></IconButton></Tooltip></> )}
            </Typography>
            <Typography variant="body1">
                Match {ruleset.match_type === RULES_MATCH_ANY ? 'any' : 'all'} of the following rules
            </Typography>
            <List dense disablePadding>
                { +ruleset.rules?.length > 0 ? (<>
                    {ruleset.rules.map((r, ruleIdx) => {
                        const label = `${r.negate ? 'NOT ' : ''}${NOTIFICATION_RULE_TEMPLATES[r.tpl]}`;
                        let SublabelComponent = <NotificationRuleDescription rule={r}/>
                        return <ListItem dense disablePadding key={ruleIdx}>
                            <ListItemText primary={label} secondary={SublabelComponent} />
                        </ListItem>
                    })}
                </>) : (<>
                    <Typography variant="body2">No rules in this ruleset</Typography>
                </>) }
            </List>
        </>);
    }
}

export const RulesetPreviewPopover = (props) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handlePopoverClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);
  
    return (<>
          <Typography
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            {props.label}
          </Typography>
          <Popover
            id="mouse-over-popover"
            sx={{ pointerEvents: 'none' }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Paper><Box sx={{ padding: theme.spacing(2) }}><RulesetPreview {...props} /></Box></Paper>
          </Popover>
    </>);    
}

export default RulesetPreview;
